/**
 * @desc undefined
 */
import {
  SendCodeResult,
  SendCodeWithCaptchaOption
} from '@eastcoal/api/nexus/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type SendSmsCodeWithCaptchaParameter = SendCodeWithCaptchaOption

const method = 'POST'
const url = '/nexus/sms/code/sendWithCaptcha'

export const sendSmsCodeWithCaptchaApi = (
  data?: SendSmsCodeWithCaptchaParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<SendCodeResult>({
    method,
    url,
    data,
    ...config
  })
}

sendSmsCodeWithCaptchaApi.method = method
sendSmsCodeWithCaptchaApi.url = url
